import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getPurchaseInput,
  getPurchasesInput,
  PurchaseLiteModel,
  PurchaseModel,
} from './model';
import { PurchaseDetailModel } from '../model';

export function useGetPurchases(
  input?: getPurchasesInput,
  options?: UseQueryOptions<ExtendedApiResult<PurchaseLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<PurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['purchases', input?.params],
      () =>
        QueryFetchFunction({
          url: 'purchases',
          params: input?.params,
        }),
      options,
    ),
    PurchaseLiteModel,
  );
}

export function useGetPurchase(
  input?: getPurchaseInput,
  options?: UseQueryOptions<ApiResult<PurchaseModel>, ApiError>,
): UseQueryResult<ApiResult<PurchaseModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['purchases', input?.id],
      () =>
        QueryFetchFunction({
          url: `purchases/${input?.id}`,
        }),
      options,
    ),
    PurchaseModel,
  );
}

export function useGetPurchaseDetail(
  input?: getPurchaseInput,
  options?: UseQueryOptions<ApiResult<PurchaseDetailModel>, ApiError>,
): UseQueryResult<ApiResult<PurchaseDetailModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['get-purchases', input?.id],
      () =>
        QueryFetchFunction({
          url: `purchases/get-purchases/${input?.id}`,
        }),
      options,
    ),
    PurchaseDetailModel,
  );
}

export function getPurchasesKey(input?: getPurchasesInput) {
  return ['purchases', input?.params];
}

export function getPurchaseKey(input?: getPurchaseInput) {
  return ['purchases', input?.id];
}

export function getPurchaseDetailKey(input?: getPurchaseInput) {
  return ['get-purchases', input?.id];
}
